import { enGB } from './en-GB';
import { daDK } from './da-DK';
import { LocalisationDictionary } from './localisationDictionary';
import { enUS } from './en-US';

export type LanguageData = { [locale: string]: LocalisationDictionary };

// Additional LocalisationDictionary languages must be added here and the key must match the locale string as key.
export const localisationDictionary: LanguageData = {
    en: enGB,
    'en-GB': enGB,
    'da-DK': daDK,
    'en-US': enUS,
};
